const PENDING_REWARD_CLAIM_TOKENS_KEY = 'pending-reward-claim-tokens-v1';

const isObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);

const normalizeRewardClaimToken = (value) => {
  if (!isObject(value)) {
    return null;
  }

  const token = typeof value.token === 'string' ? value.token.trim() : '';
  if (!token) {
    return null;
  }

  const resources = Array.isArray(value.resources)
    ? value.resources.filter((resource) => typeof resource === 'string' && resource.trim())
    : [];

  return {
    token,
    scope: typeof value.scope === 'string' && value.scope.trim() ? value.scope : 'single_game',
    resources,
    expires_at: typeof value.expires_at === 'string' ? value.expires_at : null,
  };
};

export const normalizeRewardClaimTokens = (value) => {
  if (!Array.isArray(value)) {
    return [];
  }

  const seen = new Set();
  return value.reduce((tokens, tokenValue) => {
    const normalizedToken = normalizeRewardClaimToken(tokenValue);
    if (!normalizedToken || seen.has(normalizedToken.token)) {
      return tokens;
    }
    seen.add(normalizedToken.token);
    tokens.push(normalizedToken);
    return tokens;
  }, []);
};

export const readPendingRewardClaimTokens = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_REWARD_CLAIM_TOKENS_KEY);
    if (!raw) {
      return [];
    }
    return normalizeRewardClaimTokens(JSON.parse(raw));
  } catch (_) {
    return [];
  }
};

export const storePendingRewardClaimTokens = (tokens) => {
  const normalizedTokens = normalizeRewardClaimTokens(tokens);
  try {
    if (normalizedTokens.length === 0) {
      sessionStorage.removeItem(PENDING_REWARD_CLAIM_TOKENS_KEY);
    } else {
      sessionStorage.setItem(PENDING_REWARD_CLAIM_TOKENS_KEY, JSON.stringify(normalizedTokens));
    }
  } catch (_) {}
  return normalizedTokens;
};

export const clearPendingRewardClaimTokens = () => {
  try {
    sessionStorage.removeItem(PENDING_REWARD_CLAIM_TOKENS_KEY);
  } catch (_) {}
};
